import { render, staticRenderFns } from "./Authentification.vue?vue&type=template&id=88fd8d90&scoped=true&"
import script from "./Authentification.vue?vue&type=script&lang=js&"
export * from "./Authentification.vue?vue&type=script&lang=js&"
import style0 from "./Authentification.vue?vue&type=style&index=0&id=88fd8d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fd8d90",
  null
  
)

export default component.exports